import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Loja } from "../../../../services/Lojas";

export const useLojaLista = () => {
  const query = useQuery({
    queryKey: ["loja-lista"],
    queryFn: () => Loja.get({ ativo: true }),
    select: (response) => response.data.content,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
